
<div class="sideBarContent content" *ngIf="!isLoading">
  <irb-editor-sidebar-banner *ngIf="!isUiTest"
  [accordian]="accordian" 
  [showUnsavedChangesWarning]="showUnsavedChangesWarning" 
  [isModified]="isModified"
  [isValid]="isValid"
  [hasPendingFunction]="hasPendingFunction"
  (save)="save()"
  (cancel)="cancel()"><span header class="ms-header" tooltip [tooltipTitle]="'Edit Multiple Accounts'" [tooltipRequiresTruncation]="true">Edit Multiple Accounts</span></irb-editor-sidebar-banner>
  <div class="body" [style.height]="bodyHeight" #body>

    <div class="dblock editorDisplayBanner">
      <div class="block bold">{{multipleAccountEditRequest.accountCount}} Accounts</div>
      <div class="dblock"><a (click)="showAccountMultieditView()">View accounts</a></div>
      <div class="note">External and/or SMA accounts cannot be edited when editing multiple accounts. Although selected, these accounts will not be included with other accounts you are about to edit.</div>
    </div>

    <mat-accordion #accordian="matAccordion" [multi]="true">
        <mat-expansion-panel id="SPECIAL_TREATMENT" [expanded]="ies.getDefaultExpansionState('SPECIAL_TREATMENT')" (opened)="ies.updateExpansionState('SPECIAL_TREATMENT','opened')" (closed)="ies.updateExpansionState('SPECIAL_TREATMENT','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Special Treatment
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div *ngIf="data">
                <div><label style="margin-right:5px;"><input type="checkbox" name="isDoNotTrade" [indeterminate]="data.isDoNotTrade === null" [(ngModel)]="data.isDoNotTrade" (change)="onInputChange()">Mark
                    As Frozen</label><span id="markAsFrozenToolTipIcon" class="infoIcon toolTipIcon" calltoaction
                                           [calltoactionTemplate]="markAsFrozenToolTipIcon"></span>
                </div>
                <div class="reinvest-flex-container">
                    <div class="reinvest-flex-child-left">
                        <div><label><input type="checkbox" name="isDividendReinvest" [indeterminate]="data.isDividendReinvest === null"
                                           [(ngModel)]="data.isDividendReinvest"
                                           (change)="validateReinvestChange($event)">Reinvest dividends</label>
                        </div>
                        <div><label><input type="checkbox" name="isCapGainsReinvest" [indeterminate]="data.isCapGainsReinvest === null"
                                           [(ngModel)]="data.isCapGainsReinvest"
                                           (change)="validateReinvestChange($event)">Reinvest capital gains</label>
                        </div>
                    </div>
                    <div class="reinvest-flex-child-right">
                        <span class="reinvestmentScreenText">Select whether to automatically reinvest either dividends or capital gains - or both - for selected accounts.</span>
                    </div>

                </div>
            </div>
          </ng-template>
        </mat-expansion-panel>

        <mat-expansion-panel id="SMA" *ngIf="data.isSMAapplicable" 
          [expanded]="ies.getDefaultExpansionState('SMA')" 
          (opened)="ies.updateExpansionState('SMA','opened')" 
          (closed)="ies.updateExpansionState('SMA','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Separately Managed Account
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            content to come
          </ng-template>
        </mat-expansion-panel> 
        
        <mat-expansion-panel id="CASH_NEEDS" [expanded]="ies.getDefaultExpansionState('CASH_NEEDS')" (opened)="ies.updateExpansionState('CASH_NEEDS','opened')" (closed)="ies.updateExpansionState('CASH_NEEDS','closed')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Cash Needs
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div  [ngClass]="{'block': isDistHoldCashEnabled, 'bottomBorder': isDistHoldCashEnabled}" style="display: flex; flex-direction: row; gap: 10px;">
              <div style="width: 150px">
                <strong>Maintained Cash</strong>
                @if (!isCashEqvEnabled) {
                  <span id="maintainedCashToolTipIcon" class="infoIcon toolTipIcon" calltoaction [calltoactionTemplate]="maintainedCashToolTipIcon"></span>
                }
              </div>
              <div>
                <div class="block">
                @if (isCashEqvEnabled) {
                    Configure default cash targets to be maintained in your accounts. You can set a minimum for cash only and a range for cash and cash equivalents. At the account level, targets may be set as a % of account value or a specific $ amount.
                }
                @if (!isCashEqvEnabled) {
                    Configure default cash targets to be maintained in your accounts. At the account level, targets may be set as a % of account value or a specific $ amount.
                }
                </div>
                @if (isCashEqvEnabled) {
                <div class="block"><irb-expando-link text="How does iRebal handle cash settings?">
                <div><b>Cash Only</b><br>
                You can set a minimum amount of transactional cash (otherwise known as everyday cash or operational cash) that can be used to purchase investments, pay bills, and manage daily expenses.
                </div>
                <div style="height:15px;"></div>
                <div><b>Cash & Cash Equivalents</b><br>
                Set a target for maintained cash and any cash equivalents, including purchased money market funds. iRebal will check each account's available cash, as well as any configured cash equivalents, to ensure they are inside your configured allocation range. Anything outside of this range will be brought to target.
                </div>
                <div style="height:15px;"></div>
                <div>Note: iRebal considers income cash to be available cash.</div>
                </irb-expando-link></div>
                <div class="dblock">
                    <div class="left">
                      <div class="bold">Cash Only</div>
                      <irb-dropdown-filter #trxCashMinSettingRef
                               [value]="trxCashMinSetting"
                               (search)="populateTrxCashMinSettingDropdown($event)"
                               (selection)="setTrxCashMinSetting($event)"
                               placeholder="-Select-"
                               size="19" hoverPanelWidth="160"></irb-dropdown-filter>
                    </div>
                    <div class="left ml-12" style="height:44px;">
                      <div>&nbsp;</div>
                      <p-radioButton
                        name="is-percent" inputId="editormultacctisPercentageD" [value]="'D'" [(ngModel)]="trxCashMinInd" [disabled]="trxCashMinSetting?.value !== 'Set custom'"
                        (ngModelChange)="onExpressCashMinAs()"></p-radioButton>
                        <label for="editormultacctisPercentageD" style="margin-right:5px;">$</label>
                      <p-radioButton
                        name="is-percent" inputId="editormultacctisPercentageP" [value]="'P'" [(ngModel)]="trxCashMinInd" [disabled]="trxCashMinSetting?.value !== 'Set custom'"
                        (ngModelChange)="onExpressCashMinAs()"></p-radioButton>
                        <label for="editormultacctisPercentageP" style="margin-right:5px;">%</label>
                    </div>
                    <div class="left" style="margin-left:12px;">
                      <div [ngClass]="{'disabled': trxCashMinSetting?.value === 'Set global'}"> Minimum</div>
                      <irb-number-text-box *ngIf="trxCashMinSetting?.value !== 'Set global' && !(trxCashMinInd === 'D')"
                              #trxCashMinValueRef [(value)]="trxCashMinValue" (valueChange)="onTrxCashMinValueChange()"
                              invalidMessage="The value entered is not valid."
                              invalidRangeMessage="The value entered is not valid." width="145px"
                              width="90px"
                              [isPercentage]="true" [min]="-100" [max]="100" [places]="2"  [disabled]="trxCashMinSetting?.value !== 'Set custom'"
                              [isRequired]="trxCashMinSetting?.value === 'Set custom'"></irb-number-text-box>
                      <irb-number-text-box *ngIf="trxCashMinSetting?.value !== 'Set global' && (trxCashMinInd === 'D')"
                              #trxCashMinValueRef [(value)]="trxCashMinValue" (valueChange)="onTrxCashMinValueChange()"
                              invalidMessage="The value entered is not valid."
                              invalidRangeMessage="The value entered is not valid." width="145px"
                              width="90px" [disabled]="trxCashMinSetting?.value !== 'Set custom'"
                              [isCurrency]="true" [places]="0"
                              [isRequired]="true"></irb-number-text-box>
                      <irb-number-text-box *ngIf="this.globalSettings && trxCashMinSetting?.value === 'Set global'"
                              #trxCashMinValueRef width="145px"
                              width="90px"
                              [isPercentage]="true" [min]="0" [max]="100" [places]="2"  [disabled]="true"
                              [placeholder]="'Various'"></irb-number-text-box>
                    </div>
                    <div class="clear"></div>
                </div>
                }
                <div class="dblock">
                    <div class="left">
                      <div class="bold">Cash & Cash Equivalents</div>
                      <irb-dropdown-filter #cashEquivSettingRef
                               [value]="cashEquivSetting"
                               (search)="populateCashEquivSettingDropdown($event)"
                               (selection)="setCashEquivSetting($event)"
                               size="19" hoverPanelWidth="160"></irb-dropdown-filter>
                    </div>
                    <ng-container *ngIf="data.isPercentage">
                    <div class="left ml-12">
                        <div>&nbsp;</div>
                        <p-radioButton
                                name="is-percent" inputId="editormultacctisPercentageNo" [value]="false" [(ngModel)]="data.isPercentage" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount"
                                (ngModelChange)="onExpressAs()"></p-radioButton>
                        <label for="editormultacctisPercentageNo" style="margin-right:5px;">$</label>
                        <p-radioButton
                                name="is-percent" inputId="editormultacctisPercentageYes" [value]="true" [(ngModel)]="data.isPercentage" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount"
                                (ngModelChange)="onExpressAs()"></p-radioButton>
                        <label for="editormultacctisPercentageYes" style="margin-right:5px;">%</label>
                    </div>
                    <div class="left ml-12">
                      <div>Cash Minimum</div>
                      <irb-number-text-box
                          #cashMinPerc [(value)]="cashMinimumModel" (change)="onCashNeedsMinInputChange()"
                          invalidMessage="The value entered is not valid."
                          invalidRangeMessage="The value entered is not valid." width="100px" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount"
                          [isPercentage]="true" [min]="-100" [max]="100" [places]="2" [isRequired]="!data.isGlobal"
                          [maxConstraint]="cashTargetModel"
                          invalidMaxConstraintMessage="The value for cash target must be greater than or equal to the value for cash min."
                          [placeholder]="cashPlaceholder"></irb-number-text-box>
                    </div>
                    <div class="left ml-12">
                      <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Target</div>
                      <irb-number-text-box
                          #cashTargetPerc [(value)]="cashTargetModel" (change)="onCashNeedsTargetInputChange()"
                          invalidMessage="The value entered is not valid."
                          invalidRangeMessage="The value entered is not valid." width="100px" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount"
                          [isPercentage]="true" [min]="-100" [max]="100" [places]="2"
                          [minConstraint]="cashMinimumModel" [maxConstraint]="cashMaximumModel" [isRequired]="!data.isGlobal"
                          invalidMinConstraintMessage="The value for cash target must be greater than or equal to the value for cash min."
                          invalidMaxConstraintMessage="The value for cash maximum must be greater than or equal to the value for cash target."
                          [placeholder]="cashPlaceholder"></irb-number-text-box>
                    </div>
                    <div class="left ml-12">
                      <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Maximum</div>
                      <irb-number-text-box
                          #cashMaximumPerc [(value)]="cashMaximumModel" (change)="onCashNeedsMaxInputChange()"
                          invalidMessage="The value entered is not valid."
                          invalidRangeMessage="The value entered is not valid." width="100px" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount"
                          [isPercentage]="true" [min]="-100" [max]="100" [places]="2"
                          [minConstraint]="cashTargetModel" [isRequired]="!data.isGlobal"
                          invalidMinConstraintMessage="The value for cash maximum must be greater than or equal to the value for cash target."
                          [placeholder]="cashPlaceholder"></irb-number-text-box>
                    </div>
                    </ng-container>
                    <ng-container *ngIf="!data.isPercentage">
                    <div class="left ml-12">
                        <div>&nbsp;</div>
                        <p-radioButton
                                name="is-percent" inputId="editormultacctisPercentageNo1" [value]="false" [(ngModel)]="data.isPercentage" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount"
                                (ngModelChange)="onExpressAs()"></p-radioButton>
                        <label for="editormultacctisPercentageNo1" style="margin-right:5px;">$</label>
                        <p-radioButton
                                name="is-percent" inputId="editormultacctisPercentageYes1" [value]="true" [(ngModel)]="data.isPercentage" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount"
                                (ngModelChange)="onExpressAs()"></p-radioButton>
                        <label for="editormultacctisPercentageYes1" style="margin-right:5px;">%</label>
                    </div>
                    <div class="left ml-12">
                      <div>Cash Minimum</div>
                      <irb-number-text-box
                          #cashMinDollar [(value)]="cashMinimumModel" (change)="onCashNeedsMinInputChange()"
                          invalidMessage="The value entered is not valid."
                          invalidRangeMessage="The value entered is not valid."
                          width="100px" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount" [isCurrency]="true"
                          [maxConstraint]="cashMaximumModel" [isRequired]="!data.isGlobal"
                          invalidMaxConstraintMessage="The value for cash target must be greater than or equal to the value for cash min."
                          [placeholder]="cashPlaceholder"></irb-number-text-box>
                    </div>
                    <div class="left ml-12">
                      <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Target</div>
                      <irb-number-text-box
                          #cashTargetDollar [(value)]="cashTargetModel" (change)="onCashNeedsTargetInputChange()"
                          invalidMessage="The value entered is not valid."
                          invalidRangeMessage="The value entered is not valid."
                          width="100px" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount" [isCurrency]="true"
                          [minConstraint]="cashMinimumModel" [maxConstraint]="cashMaximumModel" [isRequired]="!data.isGlobal"
                          invalidMinConstraintMessage="The value for cash target must be greater than or equal to the value for cash min."
                          invalidMaxConstraintMessage="The value for cash maximum must be greater than or equal to the value for cash target."
                          [placeholder]="cashPlaceholder"></irb-number-text-box>
                    </div>
                    <div class="left ml-12">
                      <div [ngClass]="{'disabled': cashEquivSetting?.value !== 'custom'}">Cash Maximum</div>
                      <irb-number-text-box
                          #cashMaximumDollar [(value)]="cashMaximumModel" (change)="onCashNeedsMaxInputChange()"
                          invalidMessage="The value entered is not valid."
                          invalidRangeMessage="The value entered is not valid."
                          width="100px" [disabled]="data.isGlobal || data.isGlobal === null || data.useModelCashAtAccount" [isCurrency]="true"
                          [minConstraint]="cashTargetModel" [isRequired]="!data.isGlobal"
                          invalidMinConstraintMessage="The value for cash maximum must be greater than or equal to the value for cash target."
                          [placeholder]="cashPlaceholder"></irb-number-text-box>
                    </div>
                    </ng-container>
                    <div class="clear"></div>
                </div>
              </div>              
            </div> 
            <div *ngIf="isDistHoldCashEnabled" style="display: flex; flex-direction: row; gap: 10px;">
              <div style="width: 150px">
                <strong>Automatic Cash</strong><span id="autoCashHoldForDistToolTip" class="infoIcon toolTipIcon" calltoaction [calltoactionTemplate]="autoCashHoldForDistToolTip"></span><br/>
                <strong>Hold for</strong><br/>
                <strong>Distributions</strong>
              </div>
              <div>
                <div class="block">
                  This feature is currently <span *ngIf="globalSettings.autoCashHoldForDist">enabled</span><span *ngIf="!globalSettings.autoCashHoldForDist">disabled</span> globally. You can modify this from iRebal settings. <a (click)="openGlobalSettings()">Go to Settings</a>
                </div>
                <div class="">
                  <div class="hblock">
                    <div class="hblock">Account setting</div>
                    <p-radioButton name="autoCashHoldForDist" [disabled]="!globalSettings.autoCashHoldForDist" [value]="true" inputId="editormultacct7" [(ngModel)]="data.autoCashHoldForDist" (ngModelChange)="onInputChange()"></p-radioButton>
                      <label for="editormultacct7" style="margin-right:5px;">On</label>
                    <p-radioButton name="autoCashHoldForDist" [disabled]="!globalSettings.autoCashHoldForDist" [value]="false" inputId="editormultacct8" [(ngModel)]="data.autoCashHoldForDist" (ngModelChange)="onInputChange()"></p-radioButton>
                      <label for="editormultacct8">Off</label>
                  </div>
                  <div class="hint">Turn on or turn off an automatic cash hold for selected accounts.</div>
                </div>
              </div>
            </div>      
          </ng-template>
        </mat-expansion-panel> 
        
<!--        <mat-expansion-panel id="EXTERNAL_ACCOUNTS" *ngIf="isExternalAcct" -->
<!--          [expanded]="ies.getDefaultExpansionState('EXTERNAL_ACCOUNTS')" -->
<!--          (opened)="ies.updateExpansionState('EXTERNAL_ACCOUNTS','opened')" -->
<!--          (closed)="ies.updateExpansionState('EXTERNAL_ACCOUNTS','closed')">-->
<!--          <mat-expansion-panel-header>-->
<!--            <mat-panel-title>-->
<!--              External Accounts-->
<!--            </mat-panel-title>-->
<!--          </mat-expansion-panel-header>-->
<!--          <ng-template matExpansionPanelContent>-->
<!--            content to come-->
<!--          </ng-template>-->
<!--        </mat-expansion-panel>  -->
    </mat-accordion>      
  </div>
</div>

<ng-template #markAsFrozenToolTipIcon>
    <div>If checked, iRebal will never propose to buy/sell holdings in this account. Its holdings will still be included in allocation calculations.</div>
</ng-template>

<ng-template #maintainedCashToolTipIcon>
    <div>
        <div class="block">iRebal ensures an account maintains a certain amount of cash within the minimum cash and maximum cash amounts. Global defaults from Settings are applied unless you override them here.</div>
        <div>Note: iRebal considers income cash available cash. If you want to hold income cash aside, enter the cash amount in the account's set-aside cash (below).</div>
    </div>
</ng-template>

<ng-template #reinvestUnsupportedConfigMessage>
  <div class="block"><strong>Unsupported:</strong><br/>
  Dividends Yes, Capital Gains No</div>
  <div><strong>Supported:</strong><br/>
  Dividends Yes, Capital Gains Yes<br/>
  Dividends No, Capital Gains Yes<br/>
  Dividends No, Capital Gains No</div>
</ng-template>

<ng-template #autoCashHoldForDistToolTip>
  Distribution hold is the amount of upcoming distributions from the account. This amount will be treated as set-aside cash.
</ng-template>
